var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.segments),function(segment,i){return [(segment.highlight)?_c('span',{key:`h-${i}`,class:_vm.highlightClass || 'gl-font-bold',attrs:{"data-testid":"highlighted-segment"}},[_vm._v(_vm._s(segment.text))]):_c('span',{key:`n-${i}`,attrs:{"data-testid":"unhighlighted-segment"}},[_vm._v(_vm._s(segment.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }